
import BaseAuth from './BaseAuth';
import Passkey from "./passkey";

class Login_Passkey extends BaseAuth {

    constructor(root, settings) {
        super(root, settings);
        this.root = root;
        this.settings = settings;
        this.passkey = new Passkey(root, settings);
    }
    init() {
        // we get the element by name rsssl_validate_2fa_form
        const form = document.getElementsByName('rsssl_validate_2fa_form');

        if (!form.length) {
            this.addPasskeyButton();
        } else {
            // We check if the passkey button is already added
            const passkeyButton = document.getElementById('rsssl-passkey-button');
            if (passkeyButton) {
                // If it is, we we check if the data-autorun is enabled
                if (passkeyButton.getAttribute('data-autorun') === 'enabled') {
                    this.passkey.handlePasskeyLogin();
                }
            }
        }
    }

    addPasskeyButton() {
        const loginForm = document.getElementById('loginform');
        if (loginForm) {
            const submitButton = loginForm.querySelector('p.submit');
            if (submitButton) {
                const passkeyButtonContainer = document.createElement('div');
                passkeyButtonContainer.id = 'rsssl-passkey-button-container';
                passkeyButtonContainer.style.display = 'flex';
                passkeyButtonContainer.style.justifyContent = 'center';
                passkeyButtonContainer.style.alignItems = 'center';

                const passkeyButton = document.createElement('button');
                passkeyButton.id = 'passkey-login-button';
                passkeyButton.className = 'button button-primary';
                passkeyButton.innerText = this.settings.translatables.log_in_with_passkey;

                const orDivider = document.createElement('div');
                orDivider.className = 'or-divider';
                orDivider.innerHTML = '<span>' + this.settings.translatables.or + '</span>';

                // creating the lock icon
                const lockIcon = document.createElement('span');
                lockIcon.className = 'dashicons dashicons-lock';
                lockIcon.style.marginRight = '5px';

                // Add the lock icon to the passkey button before the text
                passkeyButton.insertBefore(lockIcon, passkeyButton.firstChild);
                passkeyButton.style.display = 'flex';
                passkeyButton.style.alignItems = 'center';
                passkeyButton.style.justifyContent = 'center';

                // Insert the custom divider after the submit button
                submitButton.parentNode.insertBefore(orDivider, submitButton.nextSibling);

                passkeyButtonContainer.appendChild(passkeyButton);

                // Append the passkey button after the custom divider
                submitButton.parentNode.insertBefore(passkeyButtonContainer, orDivider.nextSibling);

                // Error display below the passkey button
                const errorContainer = document.createElement('div');
                errorContainer.id = 'rsssl-passkey-error';
                errorContainer.style.display = 'none';
                errorContainer.style.color = 'red';
                errorContainer.style.fontSize = '12px';
                errorContainer.style.marginTop = '10px';
                errorContainer.style.textAlign = 'center';
                errorContainer.style.width = '100%';
                errorContainer.style.wordWrap = 'break-word';
                errorContainer.style.wordBreak = 'break-all';

                // Move this line to ensure errorContainer is appended outside any flex elements
                submitButton.parentNode.insertBefore(errorContainer, passkeyButtonContainer.nextSibling);

                // Add event listener to the passkey button using an arrow function to maintain the context of 'this'
                passkeyButton.addEventListener('click', (event) => {
                    this.passkey.handlePasskeyLogin(event);
                });
            }
        }
    }
}
export default Login_Passkey;
